import * as React from "react";
import {
    Box,
    Typography
} from "@mui/material";
import icon1 from "../../../assets/images/icon1.svg";
import icon2 from "../../../assets/images/icon2.svg";
import icon3 from "../../../assets/images/icon3.svg";
import icon4 from "../../../assets/images/icon4.svg";
import icon5 from "../../../assets/images/icon5.svg";
import { translate } from "../../translate/translate";
import InfoCard from "../../components/info-card/info-card.component";
import {DashboardCards} from "../../models/basic/dashboard";
import {useEffect} from "react";
import {DashboardService} from "../../services/dashboard-service";
import {formatNumber} from "../../utils/format-number";
import {useNavigate} from "react-router-dom";
import {URLS} from "../../services/routes";
import TotalChartsComponent from "./total-charts.component";
import CategoryChartsComponent from "./category-charts.component";

const DashboardComponent = () => {

    const service = new DashboardService();
    const [dashboardCards, setDashboardCards] = React.useState<DashboardCards | undefined>(undefined);

    const navigate = useNavigate();

    useEffect(() => {
        loadDashboardCards();
    }, []);

    const loadDashboardCards = () => {
        service.getDashboardCards().then(response => {
            setDashboardCards(response.data);
        });
    }

    return (
        <section style={{maxWidth: "calc(98vw - 150px)", alignItems: "center", margin: "0 auto"}}>
            <div className="floating-title" style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                <Typography variant={"h5"}>
                    {translate.t("dashboard")}
                </Typography>
            </div>

            <Box sx={{
                marginTop: "16px",
                display: "grid",
                gap: "20px",
                flexWrap: "wrap",
                gridTemplateColumns: "repeat(auto-fit, minmax(18%, 1fr))"
            }}>
                <InfoCard
                    type="sec" title={translate.t("total_nre")}
                    prefix='R$'
                    description={formatNumber(dashboardCards?.total_nre || 0)}
                    src={icon1}
                    variantTitle='subtitle1'
                    cardRadius='25px'
                />
                <InfoCard
                    type="sec" title={translate.t("total_amortized")}
                    prefix='R$'
                    description={formatNumber(dashboardCards?.total_amortized || 0)}
                    src={icon2}
                    variantTitle='subtitle1'
                    cardRadius='25px'
                />
                <InfoCard
                    type="sec" title={translate.t("open_nre")}
                    prefix='R$'
                    description={formatNumber(dashboardCards?.open_nre || 0)}
                    src={icon3}
                    variantTitle='subtitle1'
                    cardRadius='25px'
                />
                <InfoCard
                    type="sec"
                    title={translate.t("qty_po_partial")}
                    description={dashboardCards?.qty_po_partial || 0}
                    src={icon4}
                    selectCard={() => {
                        navigate(URLS.PO_MONITORING + '?status=1');
                    }}
                    backgroundColor={"#fff"}
                    hoverBackgroundColor={"#DCEAFF"}
                    variantTitle='subtitle1'
                    cardRadius='25px'
                    animated={true}
                />
                <InfoCard
                    type="sec"
                    title={translate.t("qty_po_added")}
                    description={dashboardCards?.qty_po_added || 0}
                    src={icon5}
                    selectCard={() => {
                        navigate(URLS.PO_MONITORING + '?is_uncategorized=true');
                    }}
                    backgroundColor={"#fff0d7"}
                    hoverBackgroundColor={"#FFDFAC"}
                    variantTitle='subtitle1'
                    cardRadius='25px'
                    animated={true}
                    animatedStyle ={{
                        bottom: 0,
                        right: 0,
                        width: '200%',
                        height: '200%',
                        backgroundColor: "#FFDFAC",
                        borderRadius: '100% 0 0 0',
                        transform: 'scale(0)',
                        transformOrigin: 'bottom right',
                    }}
                />
            </Box>

            <Box style={{marginTop: "16px"}}>
                <TotalChartsComponent></TotalChartsComponent>
            </Box>

            <Box style={{marginTop: "16px"}}>
                <CategoryChartsComponent></CategoryChartsComponent>
            </Box>
        </section>
    );
};

export default DashboardComponent;
